import DoDontExample from './DoDontExample';

export default DoDontExample;
